module.exports = __webpack_public_path__ + "img/scene_1.159800b8.jpg";